import { useEffect, useState } from "react";

export const APPROVAL_STATUSES = ["Draft", "Needs Review", "Approved for Sample", "Sample Ordered", "Sample Approved"];

function MerchPrintNotes({ notes, onSave }) {
  const [draft, setDraft] = useState(notes);
  const [saveState, setSaveState] = useState("Saved");

  useEffect(() => setDraft(notes), [notes]);
  useEffect(() => {
    if (draft.approvalStatus === notes.approvalStatus && draft.notes === notes.notes) return undefined;
    setSaveState("Unsaved");
    const timeout = setTimeout(() => {
      onSave({ ...draft, lastUpdated: new Date().toISOString() });
      setSaveState("Saved");
    }, 500);
    return () => clearTimeout(timeout);
  }, [draft, notes, onSave]);

  const clearNotes = () => {
    if (!window.confirm("Clear the Identity Tee print notes? Placement settings will not be changed.")) return;
    const cleared = { approvalStatus: "Needs Review", notes: "", lastUpdated: new Date().toISOString() };
    setDraft(cleared);
    onSave(cleared);
    setSaveState("Saved");
  };

  return (
    <section style={panelStyle} aria-labelledby="print-notes-heading">
      <div style={headingRowStyle}><h2 id="print-notes-heading" style={{ margin: 0, fontSize: "22px" }}>Print Notes</h2><span aria-live="polite" style={{ color: saveState === "Saved" ? "#87ad91" : "#c8a56a", fontSize: "12px" }}>{saveState}</span></div>
      <label style={labelStyle}>Approval status<select value={draft.approvalStatus} onChange={(event) => setDraft((current) => ({ ...current, approvalStatus: event.target.value }))} style={fieldStyle}>{APPROVAL_STATUSES.map((status) => <option key={status}>{status}</option>)}</select></label>
      <label style={labelStyle}>Notes<textarea value={draft.notes} onChange={(event) => setDraft((current) => ({ ...current, notes: event.target.value }))} placeholder="Raise back artwork slightly, compare Bone contrast, verify front logo size." rows={6} style={{ ...fieldStyle, padding: "12px", resize: "vertical" }} /></label>
      <p style={{ color: "#777", fontSize: "12px" }}>Last updated: {notes.lastUpdated ? new Date(notes.lastUpdated).toLocaleString() : "Not yet saved"}</p>
      <button type="button" onClick={clearNotes} style={buttonStyle}>Clear Notes</button>
    </section>
  );
}

const panelStyle = { padding: "24px", border: "1px solid #2d2d2d", borderRadius: "18px", background: "#181818" };
const headingRowStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", gap: "14px", marginBottom: "22px" };
const labelStyle = { display: "block", marginBottom: "18px", fontWeight: 800 };
const fieldStyle = { display: "block", width: "100%", minHeight: "46px", marginTop: "9px", border: "1px solid #3a3a3a", borderRadius: "8px", background: "#111", color: "white", boxSizing: "border-box" };
const buttonStyle = { minHeight: "44px", padding: "0 14px", border: "1px solid #444", borderRadius: "8px", background: "transparent", color: "#ff8b87", cursor: "pointer" };

export default MerchPrintNotes;
